module.exports = __webpack_public_path__ + "static/media/vivo-banner-bg.aa9dfffb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/vivo/vivo-banner-bg.png
// module id = 911
// module chunks = 7